import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../shared/services/shared.service';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit, AfterViewInit  {

  @ViewChild('pdfViewer', { static: true }) pdfViewerRef!: ElementRef<HTMLDivElement>;

  private pdfJsLib: any;

  // PDF URL
  pdfUrl = "";

  constructor(private route: ActivatedRoute, private _sharedService : SharedService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const file = params['file'];
      if (file) {
        this.pdfUrl = decodeURIComponent(file); // decode it back
      }
    });
  }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Disable F12, Ctrl+U, Ctrl+P, Ctrl+S, Ctrl+Shift+I/J/C for print, save, inspect etc.
    if (
      event.key === 'F12' ||
      (event.ctrlKey && (event.key.toLowerCase() === 'u' || event.key.toLowerCase() === 'p' || event.key.toLowerCase() === 's')) ||
      (event.ctrlKey && event.shiftKey && ['i', 'j', 'c'].includes(event.key.toLowerCase()))
    ) {
      event.preventDefault();
    }
  }

  ngAfterViewInit(): void {
    // Load the scripts dynamically, then load PDF
    this.loadPdfJsScripts().then(() => {
      this.loadPdf();
    }).catch(err => {
      console.error('Failed to load PDF.js scripts', err);
      this.pdfViewerRef.nativeElement.innerText = 'Could not load document.';
    });
  }

  loadPdfJsScripts(): Promise<void> {
    return new Promise((resolve, reject) => {
      // Check if pdfjsLib already loaded
      if ((window as any)['pdfjsLib']) {
        this.pdfJsLib = (window as any)['pdfjsLib'];
        resolve();
        return;
      }

      // Load pdf.min.js
      const script1 = document.createElement('script');
      script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js';
      script1.onload = () => {
        // Load pdf.worker.min.js not as script but set workerSrc
        (window as any)['pdfjsLib'].GlobalWorkerOptions.workerSrc =
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
        this.pdfJsLib = (window as any)['pdfjsLib'];
        resolve();
      };
      script1.onerror = reject;

      document.body.appendChild(script1);
    });
  }

  loadPdf() {
    const container = this.pdfViewerRef.nativeElement;
    container.innerHTML = '';
    this._sharedService.callLoader();
    // Determine scale based on screen width for responsiveness and device pixel ratio for crispness
    const isMobile = window.innerWidth < 768;
    const devicePixelRatio = window.devicePixelRatio || 1;
    const scale = isMobile ? devicePixelRatio * 0.8 : devicePixelRatio * 1.3;
    this.pdfJsLib.getDocument(this.pdfUrl).promise.then((pdf: any) => {
      const renderPromises: Promise<any>[] = [];
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const promise = pdf.getPage(pageNum).then((page: any) => {
          const viewport = page.getViewport({ scale: scale });
          const canvas: HTMLCanvasElement = document.createElement('canvas');
          const context = canvas.getContext('2d')!;
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.maxWidth = '100%';
          canvas.style.height = 'auto';
          container.appendChild(canvas);

          return page.render({
            canvasContext: context,
            viewport: viewport
          }).promise;
        });
        renderPromises.push(promise);
      }
      // Wait for all pages to render, then hide loader
      Promise.all(renderPromises).then(() => {
        this._sharedService.callLoader();
      });
    }).catch((error: any) => {
      console.error('Error loading PDF:', error);
      container.innerText = 'Could not load document.';
      this._sharedService.callLoader();
    });
  }

}
